import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VersionPath } from 'app/core/common';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { IAccountInfo } from './models/account-info';
import { PathAccountManager } from './models/account-manager-paths.enum';
import { ResponseDataTransfer, TransferDataRequest } from './models/transfer-session-model';

@Injectable({
  providedIn: 'root'
})
export class AccountManagerLayerApi {
  private readonly httpClient = inject(HttpClient);

  public transferToB2C(request: TransferDataRequest): Observable<ResponseDataTransfer> {
    const url = `${environment.btbBFF.bam.baseUrl}/${environment.btbBFF.bam.nameApi}/${VersionPath.Version1}/${PathAccountManager.Session}/${PathAccountManager.TransferToB2C}`;
    return this.httpClient.post<ResponseDataTransfer>(url, request);
  }

  public createSharedCookie(): Observable<boolean> {
    const url = `${environment.btbBFF.bam.baseUrl}/${environment.btbBFF.bam.nameApi}/${VersionPath.Version1}/${PathAccountManager.Session}/${PathAccountManager.CreateSharedCookie}`;
    const optionalsConfig = { withCredentials: true };
    return this.httpClient.post<boolean>(url, {}, optionalsConfig);
  }

  public accountInfo(): Observable<IAccountInfo> {
    const url = `${environment.btbBFF.bam.baseUrl}/${environment.btbBFF.bam.nameApi}/${VersionPath.Version1}/${PathAccountManager.Account}`;
    return this.httpClient.get<IAccountInfo>(url);
  }
}
